import { StaffPackage } from "models/packages";
import { useAuthenticatedRequestCreator } from "./useRequests";

const usePackagesForAccount = () => {
    const getPackagesForAccount = useAuthenticatedRequestCreator<StaffPackage[], string>(accountId => ({
        method: "get",
        url: `/packages/account/${accountId}`
    }));

    return { getPackagesForAccount };
};

export default usePackagesForAccount;